/* eslint-disable arrow-body-style */
import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = {
  name: string;
  numeric?: boolean;
  width?: 'full' | 'three-quarters' | 'two-thirds' | 'one-half' | 'one-third' | 'one-quarter';
  autoFill?: {
    keys: string[];
    field: string;
  };
} & ComponentPropsWithoutRef<'input'>;

const Input = forwardRef<HTMLInputElement, Props>(
  ({ numeric, width = 'three-quarters', ...props }, ref) => {
    return (
      <input
        {...props}
        type={props.type || 'text'}
        className={`govuk-input govuk-!-width-${width} ${props.className ?? ''}`.trim()}
        ref={ref}
        inputMode={numeric ? 'numeric' : 'text'}
        data-testid={props.name}
        onFocus={(e) =>
          e.target.addEventListener('wheel', (e) => e.preventDefault(), { passive: false })
        }
        style={props.style}
      />
    );
  },
);
Input.displayName = 'Input';

export default Input;
